import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { WhatYouGet } from './components/WhatYouGet';
import { Benefits } from './components/Benefits';
import { FaqSection } from './components/FaqSection';
import { InstantAccess } from './components/InstantAccess';
import { Guarantee } from './components/Guarantee';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
interface AppProps {
  /** Show the limited-offer countdown block under the What You Get CTA. */
  showUrgencyBanner?: boolean;
  /** Full-bleed stadium hero, or a split hero led by the product bundle. */
  heroVariant?: 'stadium' | 'bundle';
}
export function App({
  showUrgencyBanner = true,
  heroVariant = 'stadium'
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-navy-950 font-sans" data-id="element-0" data-mp="23utcq6luo6cd">
      <main data-id="element-1" data-mp="3ik7fce9tu7pl">
        <Hero variant={heroVariant} data-id="element-2" data-mp="3ikh5q2ysagvt" />
        <SocialProof data-id="element-3" data-mp="3ijfthv617oci" />
        <WhatYouGet data-id="element-4" data-mp="3ii4sg33z0up3" />
        <FinalCta data-id="element-5" data-mp="3mlayb9n68jv1" />
        <Benefits data-id="element-6" data-mp="3mkrchhuehbbq" />
        <FaqSection data-id="element-7" data-mp="3mk84otygs3bf" />
        <InstantAccess showUrgency={showUrgencyBanner} data-id="element-8" data-mp="3mjg9vlcoy9m7" />
        <Guarantee data-id="element-9" data-mp="3rbzq6q2rjiup" />
      </main>
      <SiteFooter data-id="element-10" data-mp="3rd1all5o5hp3" />
    </div>;
}